<template>
  <div class="root">
    <button v-if="step == 4 " class="btn-quotation btn-accept" type="button" data-toggle="modal" :data-target="`#acceptOrderModal${order.id}`">ฉันได้รับสินค้าแล้ว</button>
    <div class="box-step">
      <ul class="progressbar">
        <li :class="`${step >= 1 ? 'active' : ''}`">
          <i class="far fa-edit"></i>
          <span>มีคำสั้งซื้อใหม่่</span>
          <small>{{order.get('purchaseDate') | moment('DD/MM/YYYY')}}</small>
        </li>
        <li :class="`${step >= 2 ? 'active' : ''}`">
          <i class="far fa-check-square"></i>
          <span>คำสั่งซื้อได้รับการยืนยัน</span>
          <small v-if="step >= 2">{{order.get('receiptDate') | moment('DD/MM/YYYY')}}</small>
        </li>
        <li :class="`${step >= 3 ? 'active' : ''}`">
          <i class="fas fa-truck-loading"></i>
          <span>รอจัดส่ง</span>
          <small v-if="step >= 3 ">{{order.get('receiptDate') | moment('DD/MM/YYYY')}}</small>
        </li>
        <li :class="`${step >= 4 ? 'active' : ''}`">
          <i class="fas fa-truck"></i>
          <span>กำลังจัดส่ง</span>
          <div v-if="order.get('delivery')">
            <small v-for="(delivery , index) in order.get('delivery')" :key="index">
              ไปรษณีย์ไทย {{delivery.tracking}}<br>
            </small>
            <small>
              {{order.get('delivery')[0].shippingDate | moment('DD/MM/YYYY')}}
            </small>
          </div>
        </li>
        <li :class="`${step >= 5 ? 'active' : ''}`">
          <i class="far fa-star"></i>
          <span>ตรวจสอบและได้รับสินค้า</span>
          <small v-if="step >= 3 ">{{order.get('acceptDate') | moment('DD/MM/YYYY')}}</small>
        </li>
      </ul>
    </div>
    <!-- Modal Confirm -->
    <div class="modal fade" :id="`acceptOrderModal${order.id}`" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">ยืนยันได้รับสินค้าแล้ว</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            ฉันได้รับสินค้าแล้ว และได้ตรวจสอบสินค้าแล้วว่าถูกตามรายการสั้งซื้อ
          </div>
          <div class="modal-footer">
            <button type="button" class="btn-main" :class="`${isSaveing ? 'non-active' : ''}`" style="margin:0 10px;width:80px;border-radius: 2px;"  @click="acceptOrder()">ยืนยัน</button>
            <button type="button" class="btn-quotation" :class="`${isSaveing ? 'non-active' : ''}`" style="margin:0;width:80px;border-radius: 2px;" data-dismiss="modal">ยกเลิก</button>
          </div>
        </div>
      </div>
    </div>
    <!-- End Modal Confirm -->
  </div>
</template>
<script>
export default {
  props:['order'],
  data () {
    return {
      step: 1,
      isSaveing: false
    }
  },
  created() {
    this.calStep()
  },
  methods: {
    calStep(){
      if (this.order.get('isConfirm')) {
        this.step = 2
        if (this.order.get('deliveryStatus') == 'wait') {
          this.step = 3
        }else if (this.order.get('deliveryStatus') == 'delivered') {
          this.step = 4
          if (this.order.get('isAccept')) {
            this.step = 5
          }
        }
      }
    },
    async acceptOrder(){
      this.isSaveing = true
      this.order.set('isAccept' , true)
      this.order.set('acceptDate' , new Date())
      await this.order.save().catch(e => console.log(e))
      this.calStep()
      $(`#acceptOrderModal${this.order.id}`).modal('hide')
      this.isSaveing = false
    }
  },
}
</script>
<style scoped>
.btn-accept{
  float: right;
  width: 150px;
  border-radius: 2px;
}
.non-active{
  pointer-events: none;
  border-color: rgb(146, 146, 146);
  color: rgb(146, 146, 146);
}
.box-step{
  width: 100%;
  position: relative;
  z-index: 1;
  margin-top: 20px;
  left: -20px;
  display: inline-block;
}
.progressbar li{
  float: left;
  width: 20%;
  position: relative;
  text-align: center;
  list-style-type: none;
}
.progressbar li span{
  position: relative;
  top: -20px;
  display: block;
}
.progressbar li small{
  position: relative;
  top: -20px;
  display: block;
  color: rgb(146, 146, 146);
}
.progressbar li i{
  position: relative;
  top: -45px;
  font-size: 20px;
  display: block;
  margin: 0;
  padding: 0;
}

.progressbar li.active i{
  color: white;
}
.progressbar li:not(.active) i{
  color: rgb(146, 146, 146);
}
.progressbar li.active span{
  color: #3aac5d;
  font-weight: bold;
}
.progressbar li:before{
  content:"";
  counter-increment: step;
  width: 50px;
  height: 50px;
  border: 2px solid #bebebe;
  display: block;
  margin: 0 auto 10px auto;
  border-radius: 50%;
  line-height: 27px;
  background: white;
  color: #bebebe;
  text-align: center;
  font-weight: bold;
}
.progressbar li:after{
  content: '';
  position: absolute;
  width:100%;
  height: 5px;
  background: #ececec;
  top: 23px;
  left: -50%;
  z-index: -1;
}
.progressbar li.active:before{
 border-color: #3aac5d;
 background: #3aac5d;
 /* color: white */
}
.progressbar li.active:after{
 background: #3aac5d;
}
.progressbar li.active  li:after{
 background: #3aac5d;
}
.progressbar li.active  li:before{
border-color: #3aac5d;
background: #3aac5d;
/* color: white */
}
.progressbar li:first-child:after{
 content: none;
}
.active , i{
  color: black;
}
</style>